import { Assets, Spritesheet, Texture } from 'pixi.js'

const cache = new Map<string, Spritesheet>()

export async function loadSpritesheet(
  id: string,
  atlasUrl: string,
  jsonUrl: string
): Promise<Spritesheet> {
  if (cache.has(id)) return cache.get(id)!

  const sheet = await Assets.load({
    alias: id,
    src: jsonUrl,
    data: { imageUrl: atlasUrl },
  })

  cache.set(id, sheet)
  return sheet
}

export function getFrame(sheetId: string, frameName: string): Texture | null {
  const sheet = cache.get(sheetId)
  if (!sheet) {
    console.warn(`Spritesheet ${sheetId} not loaded`)
    return null
  }
  return sheet.textures[frameName] ?? null
}

export async function preloadLaunchAssets(): Promise<void> {
  const creatures = [
    'rell', 'crag', 'flick', 'warden',
    'orrin', 'null', 'mist', 'scorch', 'origin-founding',
  ]

  await Promise.all(
    creatures.map(id =>
      loadSpritesheet(
        id,
        `/assets/sprites/creatures/${id}/atlas.png`,
        `/assets/sprites/creatures/${id}/atlas.json`
      ).catch(() => {
        // Sprite sheet not available yet — PlaceholderSprite renders instead
      })
    )
  )
}
